import { ContasRelatorioReceitas } from "features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import moment from "moment";
import { RelatorioReceitasFields } from "core/features/relatorios/typings";

function useRelatorioReceitasPdfColumns(
  fields?: RelatorioReceitasFields[]
): PDFTableColumn<ContasRelatorioReceitas>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<ContasRelatorioReceitas>[] = [];

    if (fields?.includes("descricao")) {
      columns.push({
        title: "Descrição",
        flexGrow: 1.6,
        render: (original) => (
          <View>
            <Text>{original.descricao}</Text>
          </View>
        ),
      });
    }

    if (fields?.includes("geracao")) {
      columns.push({
        title: "Geração",
        flexGrow: 0.8,
        textAlign: "left",
        render: (original) => (
          <View>
            <Text>
              {original.createdAt
                ? moment(original.createdAt).format("DD/MM/YYYY")
                : "--"}
            </Text>
          </View>
        ),
      });
    }

    if (fields?.includes("vencimento")) {
      columns.push({
        title: "Vencimento",
        flexGrow: 0.8,
        textAlign: "left",
        render: (original) => (
          <View>
            <Text>
              {original.dataVencimento
                ? moment(original.dataVencimento).format("DD/MM/YYYY")
                : "--"}
            </Text>
          </View>
        ),
      });
    }

    if (fields?.includes("liquidacao")) {
      columns.push({
        title: "Liquidação",
        flexGrow: 0.8,
        textAlign: "left",
        render: (original) => (
          <View>
            <Text>
              {original.dataPagamento
                ? moment(original.dataPagamento).format("DD/MM/YYYY")
                : "--"}
            </Text>
          </View>
        ),
      });
    }

    if (fields?.includes("credito")) {
      columns.push({
        title: "Crédito",
        flexGrow: 0.8,
        textAlign: "left",
        render: (original) => (
          <View>
            <Text>
              {original.dataMovimentacao
                ? moment(original.dataMovimentacao).format("DD/MM/YYYY")
                : "--"}
            </Text>
          </View>
        ),
      });
    }

    if (fields?.includes("centroDeCusto")) {
      columns.push({
        title: "Centro de Custo",
        flexGrow: 0.8,
        textAlign: "left",
        render: (original) => (
          <View>
            <Text>
              {original.centroDeCusto ? original.centroDeCusto.nome : "--"}
            </Text>
          </View>
        ),
      });
    }

    if (fields?.includes("nossoNumero")) {
      columns.push({
        title: "Nosso Número",
        flexGrow: 0.8,
        textAlign: "left",
        render: (original) => (
          <View>
            <Text>{original.nossoNumero ?? "--"}</Text>
          </View>
        ),
      });
    }

    if (fields?.includes("valor")) {
      columns.push({
        title: "Total",
        flexGrow: 0.8,
        textAlign: "right",
        render: (original) => (
          <View>
            <Text>{formatMoney(original.valor)}</Text>
          </View>
        ),
      });
    }

    return columns;
  }, [fields]);
}

export default useRelatorioReceitasPdfColumns;
